import React from "react";
import { useLocation } from "react-router-dom";
import Category from "components/Category";
import { CountriesRow, CountriesListProps } from "./CountriesList.types";
import { useCountriesCategoryProps } from "./CountriesList.hooks";

const CountriesList: React.FC<CountriesListProps> = (props) => {
  const location = useLocation();
  const categoryProps = useCountriesCategoryProps(props, location);

  return (
    <div className="CountriesPage CardListPage">
      <Category<CountriesRow> {...categoryProps} />
    </div>
  );
};

export default CountriesList;
